const UserEmail = {
  data: function () {
    return {
      dirty: false,
      loading: false,
      form: {
        email1: '',
        email2: '',
      },
    };
  },
  computed: {
    user() {
      return domestiko.user;
    },
    errors() {
      const errors = [];
      if (!this.form.email1 || !this.form.email2) {
        errors.push('Por favor rellena los campos');
      }
      if (this.form.email1 !== this.form.email2) {
        errors.push('Las direcciones de correo no coinciden');
      }
      if (!this.validate()) {
        errors.push('Por favor introduce un correo electrónico válido');
      }
      return errors;
    },
  },
  methods: {
    validate() {
      return validators.email(this.form.email1);
    },
    submit: function () {
      this.dirty = true;
      if (this.errors.length) {
        return;
      }
      axios
        .post('/usuarios/correo-electronico/', {
          email: this.form.email1,
        })
        .then((res) => {
          UIkit.modal
            .alert(
              'Actualización recibida.\nSe te ha enviado un correo electrónico para que verifiques tu nueva cuenta.',
            )
            .then(() => {
              this.dirty = false;
              this.form.email1 = this.form.email2 = '';
            });
        })
        .catch((err) => {
          //console.log('Email KO!', err.response);
          switch (err.response.data.message) {
            case 'EMAIL_UNCHANGED':
              UIkit.modal.alert(
                'Debes introducir una dirección distinta a la actual.',
              );
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  template: `
      <div class="user-email">
	      <div class="uk-grid uk-grid-medium uk-child-width-1-3@m">
	          <div class="uk-margin-top">
	            <label>Correo electrónico actual</label>
	            <input type="email" class="uk-input" disabled readonly :value="user.email">
	          </div>
	          <div class="uk-margin-top">
	            <label>Nuevo correo electrónico</label>
	            <input type="email" class="uk-input" v-model="form.email1">
	          </div>
	          <div class="uk-margin-top">
	            <label>Repite el correo electrónico</label>
	            <input type="email" class="uk-input" v-model="form.email2">
	          </div>
	      </div>
	      <div class="uk-alert uk-alert-warning" v-if="dirty && errors.length">
	        <ul class="uk-list uk-list-collapse">
		        <li v-for="error in errors">
		          {{error}}
		        </li>
            </ul> 
	      </div>
	      <div class="uk-text-right uk-margin-top">
	        	<button
			        @click="submit()"
			        class="uk-button uk-button-dmtk"
		        >Actualizar correo electrónico</button>
	      </div>
      </div>
	`,
};
